"use strict";
export var DropdownTheme = /* @__PURE__ */ ((DropdownTheme2) => {
  DropdownTheme2["Light"] = "light";
  DropdownTheme2["Dark"] = "dark";
  return DropdownTheme2;
})(DropdownTheme || {});
